// extracted by mini-css-extract-plugin
export var chip = "_f7-0";
export var filterDropdown = "_f7-5";
export var filterItem = "_f7-6";
export var icon = "_f7-1";
export var removeButton = "_f7-3";
export var removeIcon = "_f7-4";
export var separator = "_f7-2";